import React from 'react';
import DateRangePicker from "../datePicker/dateRangePicker";
import {PrimaryButton} from "../index";
import DoneAllIcon from "@material-ui/icons/DoneAll";

function Index(props) {
  const {filterDates, startDate, endDate, applyFilterDate, dateFilter = false, resetFilter} = props;
  return (
    <div className='main-filter-container'>
      <DateRangePicker
        filterDates={filterDates}
        filterStartDate={startDate}
        filterEndDate={endDate}
      />
      <div className='display-flex justify-content-end'>
        <PrimaryButton
          className="mt-0"
          onClick={() => applyFilterDate()}
          value={<DoneAllIcon/>}
        />
        {(dateFilter) && <PrimaryButton
          className="mt-0"
          onClick={() => resetFilter()}
          value={'reset'}
        />
        }
      </div>
    </div>
  );
}

export default Index;
